// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__tFzPB","hideScroll":"Modal_hideScroll__bPpHe"};